export default __webpack_public_path__ + "static/media/maximise-sneakers.713365eb.svg";